import { Component, Input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { externalLoginProvider } from 'core-lib';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';

@Component({
    selector: 'app-external-login-popup',
    imports: [DialogModule, ButtonModule, TranslateModule],
    templateUrl: './external-login-popup.component.html',
    styleUrl: './external-login-popup.component.scss'
})
export class ExternalLoginPopupComponent {
  @Input() externalLoginProvider: externalLoginProvider|null = null;
  @Input() visible: boolean = false;
  onHide = output<void>();
  proceedToExternalLogin = output<void>();

  //export externalLoginProvider to template
  get externalLoginProviderEnum() {
    return externalLoginProvider;
  }


  cancel() {
    this.onHide.emit();
  }

  proceedToLogin() {
    this.proceedToExternalLogin.emit();
  }
  

}
